import { render, staticRenderFns } from "./seller-center-title.vue?vue&type=template&id=46148294&scoped=true&"
import script from "./seller-center-title.vue?vue&type=script&lang=js&"
export * from "./seller-center-title.vue?vue&type=script&lang=js&"
import style0 from "./seller-center-title.vue?vue&type=style&index=0&id=46148294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46148294",
  null
  
)

export default component.exports